export const environment = {
  production: false,
  primaryUrl: 'https://aepl-tcu4g-qa.accoladeelectronics.com:6101/api',
  ticketingToolUrl: 'https://aepl-tcu4g-qa.accoladeelectronics.com:6109/api',
  tcu4gUrl: 'https://aepl-tcu4g-qa.accoladeelectronics.com:6101/api',
  tcu2gUrl: 'https://aepl-tcu2g-qa.accoladeelectronics.com:6101/api',
  projectName: 'TCU4G',
  env: 'QA',
  PORT: 6102,
};
